module.exports = __webpack_public_path__ + "img/snowflake-01.b72c3f66.svg";